<template>
  <div :class="$style.root">
    <LayoutIntroductionHeaderComponent
      :page="attributes"
    />

    <CoreTextComponent
      v-if="attributes?.introduction"
      :string="attributes?.introduction"
      :class="$style.introduction"
    />

    <PagesProjectsListComponent
      :class="$style.list"
    />
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  data: object
}>()

const attributes = baseStrapiGetAttributes(props.data)
</script>


<style module>
.root {
  /* --layout--introduction-header--margin-bottom: calc(var(--unit--vertical) * 2); */
}

.introduction {
  composes: container from global;
  margin-top: var(--unit--default);
}

.list {
  margin-top: calc(var(--unit--vertical) * 2);
}
</style>
